import { render } from "./DuplicateNumber.vue?vue&type=template&id=99fc03ce&scoped=true"
import script from "./DuplicateNumber.vue?vue&type=script&lang=js"
export * from "./DuplicateNumber.vue?vue&type=script&lang=js"

import "./DuplicateNumber.vue?vue&type=style&index=0&id=99fc03ce&scoped=true&lang=css"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99fc03ce"]])

export default __exports__